import { isBefore, isValid } from 'date-fns';
import { RangeDate } from '../model';

const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z!@#$&*.]).{8,}$/;

const EMAIL_PATTERN = /^[A-Za-z0-9.+_-]+@([A-Za-z0-9_-]+\.)+[A-Za-z]{2,6}$/;

const PHONE_PATTERN = /^\+\d{2}[\d ]+$/;

const FISCAL_CODE_PATTERN =
  /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/;

const USER_CODE_PATTERN = /^[a-zA-Z0-9]{9}$/;

const VAT_CODE_PATTERN = /^[0-9]{11}$/;

const SQUARE_AGREEMENT_CODE_PATTERN = /^[0-9]{10}$/;

export const isPasswordValid = (password: string, username: string) =>
  password.indexOf(username) < 0 && PASSWORD_REGEX.test(password);

export const isPasswordValidTest = (password: string) =>
  PASSWORD_REGEX.test(password);

export const isEmailValid = (email: string, required = true) =>
  required ? EMAIL_PATTERN.test(email) : !email || EMAIL_PATTERN.test(email);

export const isPhoneNumberValid = (phone: string, required = true) =>
  required ? PHONE_PATTERN.test(phone) : !phone || PHONE_PATTERN.test(phone);

export const isFiscalCodeValid = (fiscalCode: string, required = true) =>
  required
    ? FISCAL_CODE_PATTERN.test(fiscalCode)
    : !fiscalCode || FISCAL_CODE_PATTERN.test(fiscalCode);

export const isUserCodeValid = (userCode: string, required = true) =>
  required
    ? USER_CODE_PATTERN.test(userCode)
    : !userCode || USER_CODE_PATTERN.test(userCode);

export const isVatCodeValid = (vatCode: string, required = true) =>
  required
    ? VAT_CODE_PATTERN.test(vatCode)
    : !vatCode || VAT_CODE_PATTERN.test(vatCode);

export const isVatCodeFiscalCodeValid = (vatCode: string, required = true) => {
  const condition =
    VAT_CODE_PATTERN.test(vatCode) || FISCAL_CODE_PATTERN.test(vatCode);
  return required ? condition : !vatCode || condition;
};

export const isSquareAgreementCodeValid = (
  squareAgreementCode: string,
  required = true
) =>
  required
    ? SQUARE_AGREEMENT_CODE_PATTERN.test(squareAgreementCode)
    : !squareAgreementCode ||
      SQUARE_AGREEMENT_CODE_PATTERN.test(squareAgreementCode);

export const isDateValid = (date: Date | null): boolean => {
  return isValid(date);
};

export const isRangeDateValid = (
  rangeDate: RangeDate,
  requiredAll?: boolean
): boolean => {
  if (rangeDate) {
    if (rangeDate.to) {
      const isValidDates = 
        isDateValid(rangeDate.from) &&
        isDateValid(rangeDate.to) &&
        isBefore(rangeDate.from, rangeDate.to);
      
      if (!isValidDates) return false;
      
      const fromDate = new Date(rangeDate.from);
      const toDate = new Date(rangeDate.to);
      const maxDate = new Date(fromDate);
      maxDate.setFullYear(fromDate.getFullYear() + 1);
      
      return isBefore(toDate, maxDate) || toDate.getTime() === maxDate.getTime();
    }

    return !requiredAll && isDateValid(rangeDate.from);
  }

  return false;
};
